"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeList = void 0;
var attribute_list_component_1 = require("./attribute-list.component");
Object.defineProperty(exports, "AttributeList", { enumerable: true, get: function () { return attribute_list_component_1.AttributeList; } });
